import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../config/queryKeys'
import {
  getUnreadNotificationCount,
  type UnreadNotificationCount,
} from '../../../services/notifications/notificationService'

/**
 * SN-7849 — the bell's unread counts for the signed-in user.
 *
 * Asks only once there is a user id, so a signed-out header never asks and a
 * sign-in (the id arriving, after a verification signs someone in) fetches the
 * new account's count straight away. Invalidating `notification.all` refreshes
 * it: the bell panel does when it closes, the invitation page after an accept.
 */
export const useUnreadNotificationCount = (
  userId?: string | null
): UnreadNotificationCount | undefined => {
  'use memo'

  const { data } = useQuery({
    queryKey: queryKeys.notification.unreadCount(userId),
    queryFn: getUnreadNotificationCount,
    enabled: Boolean(userId),
  })

  return data
}
